// //  for vendor header

// import { useState } from "react";
// import {
//   FaTh,
//   FaCalendarAlt,
//   FaChartBar,
//   FaUsers,
//   FaBell,
//   FaUser,
//   FaChevronDown,
// } from "react-icons/fa";

// export default function Header() {
//   const [openDropdown, setOpenDropdown] = useState(null);

//   const toggleDropdown = (name) => {
//     setOpenDropdown(openDropdown === name ? null : name);
//   };

//   return (
//     <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//       {/* Logo */}
//       <div className="flex items-center">
//         <img src="/upswap.png" alt="UpSwap" className="h-12 w-auto" />
//       </div>

//       {/* Center Nav */}
//       <nav className="hidden md:flex items-center space-x-6">
//         <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//           <FaTh /> Dashboard
//         </button>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("appointments")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaCalendarAlt /> Appointments <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "appointments" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Upcoming
//               </button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Past
//               </button>
//             </div>
//           )}
//         </div>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("services")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaChartBar /> Services & Deals{" "}
//             <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "services" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 All Services
//               </button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Active Deals
//               </button>
//             </div>
//           )}
//         </div>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("staff")}
//             className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//           >
//             <FaUsers /> Staff <FaChevronDown className="text-xs" />
//           </button>
//           {openDropdown === "staff" && (
//             <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Team
//               </button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Roles
//               </button>
//             </div>
//           )}
//         </div>
//       </nav>

//       {/* Right Side */}
//       <div className="flex items-center space-x-4">
//         <button className="relative">
//           <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//           <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//         </button>

//         <div className="relative">
//           <button
//             onClick={() => toggleDropdown("profile")}
//             className="flex items-center text-gray-700 hover:text-orange-500"
//           >
//             <FaUser className="text-xl" />{" "}
//             <FaChevronDown className="ml-1 text-xs" />
//           </button>
//           {openDropdown === "profile" && (
//             <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Profile
//               </button>
//               <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                 Logout
//               </button>
//             </div>
//           )}
//         </div>
//       </div>
//     </header>
//   );
// }

// src/components/VendorHeader.jsx

// import React, { useState } from "react";
// import {
//     FaTh, FaCalendarAlt, FaChartBar, FaUsers,
//     FaBell, FaUser, FaChevronDown, FaPlusSquare
// } from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';

// const VendorHeader = () => {
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

//     const navigate = useNavigate();
//     const { logout, canPostDeals, kycStatus } = useAuth(); // Use canPostDeals and kycStatus from context

//     const toggleDropdown = (name) => {
//         setOpenDropdown(openDropdown === name ? null : name);
//         setProfileDropdownOpen(false); // Close profile dropdown if another is opened
//     };

//     const toggleProfileDropdown = () => {
//         setProfileDropdownOpen(!profileDropdownOpen);
//         setOpenDropdown(null); // Close other dropdowns if profile is opened
//     };

//     const handleLogout = () => {
//         logout();
//         navigate('/');
//     };

//     const handlePostDealClick = () => {
//         if (canPostDeals) {
//             navigate('/post-deal');
//         } else if (kycStatus === 'not_submitted') {
//             alert("Deals post karne ke liye, kripya apni KYC complete karein.");
//             navigate('/kyc-submission');
//         } else if (kycStatus === 'pending') {
//             alert("Aapki KYC approval pending hai. Approval ke baad aap deals post kar payenge.");
//         } else if (kycStatus === 'rejected') {
//             alert("Aapki KYC request reject ho gayi hai. Kripya dobara submit karein ya support se contact karein.");
//             navigate('/kyc-submission');
//         }
//     };

//     return (
//         <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//             {/* Logo */}
//             <div className="flex items-center">
//                 <img src="/upswap.png" alt="UpSwap" className="h-12 w-auto" />
//             </div>

//             {/* Center Nav */}
//             <nav className="hidden md:flex items-center space-x-6">
//                 <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//                     <FaTh /> Dashboard
//                 </button>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("appointments")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaCalendarAlt /> Appointments <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "appointments" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Upcoming
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Past
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("services")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaChartBar /> Services & Deals{" "}
//                         <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "services" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 All Services
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Active Deals
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("staff")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaUsers /> Staff <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "staff" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Team
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Roles
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </nav>

//             {/* Right Side */}
//             <div className="flex items-center space-x-4">
//                 {/* Post Deal Button (only if canPostDeals is true) */}
//                 <button
//                     className={`text-xl focus:outline-none ${canPostDeals ? 'text-gray-600 hover:text-orange-500' : 'text-gray-400 cursor-not-allowed'}`}
//                     onClick={handlePostDealClick}
//                     disabled={!canPostDeals}
//                     title={canPostDeals ? "Post a New Deal" : `Deals post karne ke liye, KYC ${kycStatus === 'not_submitted' ? 'complete karein' : kycStatus === 'pending' ? 'approval pending hai' : 'rejected hai'}.`}
//                 >
//                     <FaPlusSquare />
//                 </button>

//                 <button className="relative">
//                     <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//                     <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//                 </button>

//                 <div className="relative">
//                     <button
//                         onClick={toggleProfileDropdown}
//                         className="flex items-center text-gray-700 hover:text-orange-500"
//                     >
//                         <FaUser className="text-xl" />{" "}
//                         <FaChevronDown className="ml-1 text-xs" />
//                     </button>
//                     {profileDropdownOpen && (
//                         <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Profile
//                             </button>
//                             <button
//                                 onClick={handleLogout}
//                                 className="block w-full text-left px-4 py-2 hover:bg-gray-100"
//                             >
//                                 Logout
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default VendorHeader;

// // src/components/Dashboard/VendorHeader.jsx
// import React, { useState } from "react";
// import {
//     FaTh, FaCalendarAlt, FaChartBar, FaUsers,
//     FaBell, FaUser, FaChevronDown, FaPlusSquare
// } from "react-icons/fa";
// import { useNavigate } from 'react-router-dom';
// // Corrected import path for useAuth
// // VendorHeader.jsx is in src/components/Dashboard/
// // AuthContext.js is in src/components/authentication/
// import { useAuth } from '../Authentication/AuthContext';

// const VendorHeader = () => {
//     const [openDropdown, setOpenDropdown] = useState(null);
//     const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

//     const navigate = useNavigate();
//     // Destructure logout, canPostDeals, and kycStatus from the AuthContext
//     const { logout, canPostDeals, kycStatus } = useAuth();

//     const toggleDropdown = (name) => {
//         setOpenDropdown(openDropdown === name ? null : name);
//         setProfileDropdownOpen(false); // Close profile dropdown if another is opened
//     };

//     const toggleProfileDropdown = () => {
//         setProfileDropdownOpen(!profileDropdownOpen);
//         setOpenDropdown(null); // Close other dropdowns if profile is opened
//     };

//     const handleLogout = () => {
//         logout();
//         navigate('/'); // Redirect to home/public page after logout
//     };

//     const handlePostDealClick = () => {
//         if (canPostDeals) {
//             navigate('/post-deal');
//         } else if (kycStatus === 'not_submitted') {
//             alert("Deals post karne ke liye, kripya apni KYC complete karein.");
//             navigate('/kyc-submission');
//         } else if (kycStatus === 'pending') {
//             alert("Aapki KYC approval pending hai. Approval ke baad aap deals post kar payenge.");
//         } else if (kycStatus === 'rejected') {
//             alert("Aapki KYC request reject ho gayi hai. Kripya dobara submit karein ya support se contact karein.");
//             navigate('/kyc-submission');
//         } else {
//             // Default or unknown status for more specific message
//             alert("Deals post karne ke liye apki KYC status verify nahi hai. Kripya profile check karein.");
//         }
//     };

//     return (
//         <header className="bg-white shadow-sm w-full px-4 sm:px-8 py-3 flex justify-between items-center">
//             {/* Logo */}
//             <div className="flex items-center">
//                 {/* Ensure /upswap.png is in your public folder */}
//                 <img src="/upswap.png" alt="UpSwap" className="h-12 w-auto" />
//             </div>

//             {/* Center Nav */}
//             <nav className="hidden md:flex items-center space-x-6">
//                 <button className="flex items-center gap-1 text-gray-700 hover:text-orange-500">
//                     <FaTh /> Dashboard
//                 </button>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("appointments")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaCalendarAlt /> Appointments <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "appointments" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Upcoming
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Past
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("services")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaChartBar /> Services & Deals{" "}
//                         <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "services" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 All Services
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Active Deals
//                             </button>
//                         </div>
//                     )}
//                 </div>

//                 <div className="relative">
//                     <button
//                         onClick={() => toggleDropdown("staff")}
//                         className="flex items-center gap-1 text-gray-700 hover:text-orange-500"
//                     >
//                         <FaUsers /> Staff <FaChevronDown className="text-xs" />
//                     </button>
//                     {openDropdown === "staff" && (
//                         <div className="absolute top-full left-0 bg-white shadow-lg rounded-md mt-2 w-48 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Team
//                             </button>
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Roles
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </nav>

//             {/* Right Side */}
//             <div className="flex items-center space-x-4">
//                 {/* Post Deal Button (dynamically enabled/disabled) */}
//                 <button
//                     className={`text-xl focus:outline-none ${canPostDeals ? 'text-gray-600 hover:text-orange-500' : 'text-gray-400 cursor-not-allowed'}`}
//                     onClick={handlePostDealClick}
//                     disabled={!canPostDeals}
//                     title={
//                         canPostDeals
//                             ? "Post a New Deal"
//                             : `Deals post karne ke liye, KYC ${kycStatus === 'not_submitted' ? 'complete karein' : kycStatus === 'pending' ? 'approval pending hai' : kycStatus === 'rejected' ? 'rejected hai' : 'status unknown'}.`
//                     }
//                 >
//                     <FaPlusSquare />
//                 </button>

//                 <button className="relative">
//                     <FaBell className="text-xl text-gray-700 hover:text-orange-500" />
//                     <span className="absolute top-0 right-0 bg-red-500 w-2 h-2 rounded-full"></span>
//                 </button>

//                 <div className="relative">
//                     <button
//                         onClick={toggleProfileDropdown}
//                         className="flex items-center text-gray-700 hover:text-orange-500"
//                     >
//                         <FaUser className="text-xl" />{" "}
//                         <FaChevronDown className="ml-1 text-xs" />
//                     </button>
//                     {profileDropdownOpen && (
//                         <div className="absolute top-full right-0 bg-white shadow-lg rounded-md mt-2 w-40 z-20">
//                             <button className="block w-full text-left px-4 py-2 hover:bg-gray-100">
//                                 Profile
//                             </button>
//                             <button
//                                 onClick={handleLogout}
//                                 className="block w-full text-left px-4 py-2 hover:bg-gray-100"
//                             >
//                                 Logout
//                             </button>
//                         </div>
//                     )}
//                 </div>
//             </div>
//         </header>
//     );
// };

// export default VendorHeader;

// // src/components/Dashboard/VendorHeader.jsx
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import {
//   CalendarDaysIcon,
//   ChartBarIcon,
//   UserGroupIcon,
//   BellIcon,
//   PlusCircleIcon,
//   UserCircleIcon,
//   ChevronDownIcon,
// } from "@heroicons/react/24/outline";
// import { useAuth } from "../Authentication/AuthContext";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";
// import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";

// const Maps_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I";

// const VendorHeader = () => {
//   const { logout, canPostDeals, kycStatus } = useAuth();
//   const navigate = useNavigate();

//   const [openDropdown, setOpenDropdown] = useState(null);
//   const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

// // State to manage modal visibility
//   const [showLocationModal, setShowLocationModal] = useState(false);
//   // State to store the user's selected/entered location
//   const [currentLocation, setCurrentLocation] = useState({
//     city: "Downtown",
//     state: "San Francisco, California",
//     latitude: null,
//     longitude: null,
//   });
//   // State for the manual input field in the modal
//   const [manualLocationInput, setManualLocationInput] = useState("");
//   // State to track if Google Maps API is loaded
//   const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
//   // Ref for the manual location input field in the modal to attach autocomplete
//   const locationInputModalRef = useRef(null);

//   // Variable to hold the Google Places Autocomplete instance
//   const autocompleteInstance = useRef(null);

//   // Define the initMap callback function using useCallback
//   // This is called when the Google Maps script finishes loading.
//   const initMap = useCallback(() => {
//     setIsGoogleMapsLoaded(true);
//   }, []);

//   // Load Google Maps API script dynamically and ensure it's loaded only once
//   useEffect(() => {
//     // Check if the script is already loaded
//     if (window.google && window.google.maps && window.google.maps.places) {
//       setIsGoogleMapsLoaded(true);
//       return;
//     }

//     // Assign the initMap function to the global window object BEFORE appending the script
//     // This is crucial for the Google Maps API's callback to work.
//     window.initMap = initMap;

//     // Check if a script with the Google Maps API source already exists
//     const existingScript = document.querySelector(
//       `script[src*="maps.googleapis.com/maps/api/js"]`
//     );

//     if (existingScript) {
//       // If it exists, but isn't loaded, wait for it to load
//       existingScript.onload = () => setIsGoogleMapsLoaded(true);
//       existingScript.onerror = () =>
//         toast.error("Failed to load Google Maps API.");
//       return;
//     }

//     // If not, create and append the script
//     const script = document.createElement("script");
//     // We request 'places' and 'geocoding' libraries. 'places' is essential for Autocomplete.
//     script.src = `https://maps.googleapis.com/maps/api/js?key=${Maps_API_KEY}&libraries=places&callback=initMap`;
//     script.async = true;
//     script.defer = true;
//     script.id = "google-maps-script-header"; // Unique ID for this script

//     script.onerror = () => {
//       toast.error("Failed to load Google Maps API for location services.");
//     };

//     document.head.appendChild(script);

//     return () => {
//       // Clean up the global callback when the component unmounts
//       if (window.initMap === initMap) {
//         delete window.initMap;
//       }
//     };
//   }, [initMap]); // Depend on initMap (which is stable due to useCallback)

//   // Initialize Google Places Autocomplete when modal is open and API is loaded
//   useEffect(() => {
//     if (
//       isGoogleMapsLoaded &&
//       showLocationModal &&
//       locationInputModalRef.current
//     ) {
//       // Ensure Autocomplete is only initialized once for this input
//       if (!autocompleteInstance.current) {
//         try {
//           autocompleteInstance.current =
//             new window.google.maps.places.Autocomplete(
//               locationInputModalRef.current,
//               {
//                 types: ["(cities)"], // Restrict results to cities (or 'geocode' for broader addresses)
//                 // Removed the country restriction to allow international locations
//               }
//             );

//           autocompleteInstance.current.addListener("place_changed", () => {
//             const place = autocompleteInstance.current.getPlace();

//             if (place.geometry && place.formatted_address) {
//               let city = "Unknown City";
//               let state = ""; // Default to empty for state/country
//               let latitude = place.geometry.location.lat();
//               let longitude = place.geometry.location.lng();

//               // Extract city and state/country from address_components
//               const addressComponents = place.address_components;
//               addressComponents.forEach((component) => {
//                 if (component.types.includes("locality")) {
//                   city = component.long_name;
//                 } else if (
//                   component.types.includes("administrative_area_level_1")
//                 ) {
//                   state = component.long_name;
//                 } else if (component.types.includes("country")) {
//                   // If state is not found, use country as fallback for 'state' field
//                   if (!state) {
//                     state = component.long_name;
//                   }
//                 }
//               });

//               setCurrentLocation({
//                 city: city,
//                 state: state,
//                 latitude: latitude,
//                 longitude: longitude,
//               });
//               localStorage.setItem(
//                 "userLocation",
//                 JSON.stringify({
//                   city: city,
//                   state: state,
//                   latitude: latitude,
//                   longitude: longitude,
//                 })
//               );
//               setManualLocationInput(place.formatted_address); // Update input field with selected place's full address
//               setShowLocationModal(false); // Close modal
//               toast.success("Location updated!");
//             } else {
//               toast.warn("No details available for the selected location.");
//               // If no geometry/formatted address, fall back to current input value
//               handleManualLocationSubmit(true); // Treat as manual submission
//             }
//           });
//         } catch (error) {
//           console.error("Error initializing Google Autocomplete:", error);
//           toast.error(
//             "Failed to initialize location suggestions. Please try manual entry."
//           );
//         }
//       }
//     }

//     // Cleanup: Remove listener and destroy autocomplete instance when modal closes or component unmounts
//     return () => {
//       if (autocompleteInstance.current) {
//         if (window.google && window.google.maps && window.google.maps.event) {
//           window.google.maps.event.clearInstanceListeners(
//             autocompleteInstance.current
//           );
//         }
//         autocompleteInstance.current = null;
//       }
//     };
//   }, [isGoogleMapsLoaded, showLocationModal]); // Re-run when API loads or modal state changes

//   // Effect to load location from local storage on component mount
//   useEffect(() => {
//     const storedLocation = localStorage.getItem("userLocation");
//     if (storedLocation) {
//       setCurrentLocation(JSON.parse(storedLocation));
//     }
//   }, []);

//   // New useEffect to handle body overflow when modal is open/closed
//   useEffect(() => {
//     if (showLocationModal) {
//       document.body.style.overflow = "hidden"; // Prevent scrolling
//     } else {
//       document.body.style.overflow = ""; // Allow scrolling
//     }
//     // Cleanup function to ensure overflow is reset if component unmounts while modal is open
//     return () => {
//       document.body.style.overflow = "";
//     };
//   }, [showLocationModal]); // Re-run effect whenever showLocationModal changes

//   // Function to handle opening the location modal
//   const handleLocationClick = () => {
//     setShowLocationModal(true);
//     setManualLocationInput(""); // Clear manual input when opening modal
//   };

//   // Function to handle closing the location modal
//   const handleCloseModal = () => {
//     setShowLocationModal(false);
//   };

//   // Function to get address details from coordinates using Google Geocoding API
//   const getAddressFromCoordinates = async (latitude, longitude) => {
//     if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
//       toast.error("Google Maps API not fully loaded. Please try again.");
//       return null;
//     }

//     const geocoder = new window.google.maps.Geocoder();
//     const latlng = { lat: latitude, lng: longitude };

//     try {
//       const { results } = await geocoder.geocode({ location: latlng });

//       if (results && results.length > 0) {
//         let city = "Unknown City";
//         let state = "Unknown Region";
//         let country = "Unknown Country";

//         const addressComponents = results[0].address_components;
//         addressComponents.forEach((component) => {
//           if (component.types.includes("locality")) {
//             city = component.long_name;
//           } else if (component.types.includes("administrative_area_level_1")) {
//             state = component.long_name;
//           } else if (component.types.includes("country")) {
//             country = component.long_name;
//           }
//         });

//         const displayState = state !== "Unknown Region" ? state : country;

//         return {
//           city: city,
//           state: displayState,
//           latitude,
//           longitude,
//         };
//       } else {
//         toast.warn("Could not find address details for your current location.");
//         return {
//           city: "Location Found",
//           state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
//           latitude,
//           longitude,
//         };
//       }
//     } catch (error) {
//       console.error("Error reverse geocoding with Google Maps:", error);
//       toast.error(
//         "Failed to fetch address details. Check console for more info."
//       );
//       return null;
//     }
//   };

//   // Function to get current geolocation and then reverse geocode it
//   const handleUseCurrentLocation = async () => {
//     if (!navigator.geolocation) {
//       toast.error("Geolocation is not supported by your browser.");
//       return;
//     }
//     if (!isGoogleMapsLoaded) {
//       toast.info("Loading location services... please try again shortly.");
//       return;
//     }

//     toast.info("Fetching your current location...");

//     navigator.geolocation.getCurrentPosition(
//       async (position) => {
//         const { latitude, longitude } = position.coords;
//         const locationDetails = await getAddressFromCoordinates(
//           latitude,
//           longitude
//         );

//         if (locationDetails) {
//           setCurrentLocation(locationDetails);
//           localStorage.setItem("userLocation", JSON.stringify(locationDetails));
//           toast.success("Location updated successfully!");
//         } else {
//           // Fallback if getAddressFromCoordinates returns null
//           setCurrentLocation({
//             city: "Unknown Address",
//             state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
//             latitude,
//             longitude,
//           });
//           localStorage.setItem(
//             "userLocation",
//             JSON.stringify({
//               city: "Unknown Address",
//               state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(
//                 4
//               )}`,
//               latitude,
//               longitude,
//             })
//           );
//         }
//         setShowLocationModal(false); // Close modal after fetching
//       },
//       (error) => {
//         let errorMessage = "Unable to retrieve your location.";
//         if (error.code === error.PERMISSION_DENIED) {
//           errorMessage =
//             "Location access denied. Please allow location services in your browser settings.";
//         } else if (error.code === error.POSITION_UNAVAILABLE) {
//           errorMessage = "Location information is unavailable.";
//         } else if (error.code === error.TIMEOUT) {
//           errorMessage = "The request to get location timed out.";
//         }
//         console.error("Geolocation error:", error);
//         toast.error(errorMessage);
//       }
//     );
//   };

//   // Function to handle manual location submission
//   // Added optional parameter to differentiate if called internally (e.g., from autocomplete fallback)
//   const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
//     if (manualLocationInput.trim() === "") {
//       if (!fromAutocompleteFallback) {
//         // Only warn if not a fallback from autocomplete
//         toast.warn("Please enter a location.");
//       }
//       return;
//     }

//     const parts = manualLocationInput.split(",").map((p) => p.trim());
//     const city = parts[0] || manualLocationInput.trim();
//     const state = parts.length > 1 ? parts.slice(1).join(", ") : "";

//     setCurrentLocation({
//       city: city,
//       state: state,
//       latitude: null, // No lat/lng for simple manual entry without geocoding
//       longitude: null, // No lat/lng for simple manual entry without geocoding
//     });
//     localStorage.setItem(
//       "userLocation",
//       JSON.stringify({
//         city: city,
//         state: state,
//         latitude: null,
//         longitude: null,
//       })
//     );
//     setShowLocationModal(false); // Close modal after submission
//     if (!fromAutocompleteFallback) {
//       // Only show success toast if not a fallback
//       toast.success("Manual location set successfully!");
//     }
//   };

//   const navItems = [
//     {
//       name: "Deals",
//       icon: CalendarDaysIcon,
//       dropdownItems: [
//         // { name: "Create Deal", path: "/Postdeal" },
//         { name: "Browse Deal", path: "/PopularDeals" },
//          { name: "Create Deal", path: "/vendor/deal/add" },
//          { name: "My Created Deal", path: "/MyDeals" },
//         { name: "Upcoming", path: "#", commingsoon: true },
//         { name: "Past", path: "#", commingsoon: true },
//       ],
//     },
//     {
//       name: "Calendar",
//       icon: ChartBarIcon,
//       dropdownItems: [
//         { name: "All Services", path: "#", commingsoon: true },
//         { name: "Active Deals", path: "#", commingsoon: true },
//       ],
//     },
//     {
//       name: "Staff",
//       icon: UserGroupIcon,
//       dropdownItems: [
//         { name: "Team", path: "#", commingsoon: true },
//         { name: "Roles", path: "#", commingsoon: true },
//       ],
//     },
//     {
//       name: "Services",
//       icon: UserGroupIcon,
//       dropdownItems: [
//         { name: "My Services", path: "/vendor/services" },
//         { name: "Archived", path: "#", commingsoon: true },
//       ],
//     },
//   ];

//   const handlePostDealClick = () => {
//     if (canPostDeals) {
//       navigate("/Postdeal");
//     } else if (kycStatus === "not_submitted") {
//       alert("Deals post karne ke liye, kripya apni KYC complete karein.");
//       navigate("/kyc-submission");
//     } else if (kycStatus === "pending") {
//       alert(
//         "Aapki KYC approval pending hai. Approval ke baad deals post kar sakte hain."
//       );
//     } else if (kycStatus === "rejected") {
//       alert("Aapki KYC reject ho gayi hai. Kripya dubara submit karein.");
//       navigate("/kyc-submission");
//     } else {
//       alert("KYC status verify nahi hai. Kripya profile check karein.");
//     }
//   };

//   const handleDropdownToggle = (index) => {
//     setOpenDropdown(openDropdown === index ? null : index);
//     setProfileDropdownOpen(false);
//   };

//   const handleDropdownItemClick = (item) => {
//     if (item.path && !item.commingsoon) {
//       navigate(item.path);
//       setOpenDropdown(null);
//     }
//   };

//   const handleLogout = () => {
//     logout();
//     navigate("/");
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (!e.target.closest(".nav-dropdown-container")) {
//         setOpenDropdown(null);
//       }
//       if (!e.target.closest(".profile-dropdown-container")) {
//         setProfileDropdownOpen(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
//       <div className="container mx-auto flex items-center justify-between">
//         {/* Logo */}
//         <div className="flex-shrink-0 cursor-pointer">
//           <img
//             src="/upswap.png"
//             alt="UpSwap"
//             className="h-10"
//             onClick={() => navigate("/")}
//           />
//         </div>
//       {showLocationModal && (
//               <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
//                 <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8">
//                   {/* Close Icon in top-right corner */}
//                   <button
//                     onClick={handleCloseModal}
//                     className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
//                     aria-label="Close location selection"
//                   >
//                     <FaTimes size={20} />
//                   </button>

//                   <h2 className="text-xl font-bold mb-4 text-gray-800">Select Your Location</h2>

//                   {/* Use Current Location Button */}
//                   <button
//                     onClick={handleUseCurrentLocation}
//                     disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
//                     className={`w-full py-2 px-4 rounded-md transition mb-4 ${
//                       !isGoogleMapsLoaded
//                         ? "bg-blue-300 cursor-not-allowed"
//                         : "bg-blue-500 text-white hover:bg-blue-600"
//                     }`}
//                   >
//                     <FaMapMarkerAlt className="inline-block mr-2" />
//                     {isGoogleMapsLoaded ? "Use My Current Location" : "Loading Location Services..."}
//                   </button>

//                   <div className="text-center text-gray-500 mb-4 font-semibold">- OR -</div>

//                   {/* Manual Location Input with Autocomplete */}
//                   <input
//                     type="text"
//                     ref={locationInputModalRef} // Assign ref to this input
//                     placeholder="Enter location manually (e.g., New York, USA)"
//                     className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
//                     value={manualLocationInput}
//                     onChange={(e) => setManualLocationInput(e.target.value)}
//                   />
//                   {/* The Set Location button is now primarily for when the user types and doesn't select a suggestion */}
//                   <button
//                     onClick={() => handleManualLocationSubmit()} // Call without fallback flag
//                     className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
//                   >
//                     Set Location
//                   </button>
//                   {/* Removed the old Close Button here */}
//                 </div>
//               </div>
//             )}

//         {/* Navigation */}
//         <nav className="hidden lg:flex flex-grow justify-center space-x-8">

//           {navItems.map((item, index) => (
//             <div
//               key={index}
//               className="relative flex items-center text-gray-700 hover:text-black text-sm font-medium cursor-pointer nav-dropdown-container"
//               onClick={() => handleDropdownToggle(index)}
//             >
//               {item.icon && <item.icon className="h-5 w-5 mr-1" />}
//               {item.name}
//               <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />

//               <div
//                 className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                   openDropdown === index ? "flex flex-col gap-1" : "hidden"
//                 }`}
//               >
//                 {item.dropdownItems.map((dItem, dIndex) => (
//                   <a
//                     key={dIndex}
//                     href={dItem.commingsoon ? "#" : dItem.path}
//                     className={`block px-4 py-2 text-sm relative  rounded-sm ${
//                       dItem.commingsoon
//                         ? "bg-gray-100 text-gray-400 cursor-not-allowed"
//                         : "text-gray-700 hover:bg-gray-100"
//                     }`}
//                     onClick={(e) => {
//                       e.stopPropagation();
//                       if (!dItem.commingsoon) handleDropdownItemClick(dItem);
//                     }}
//                   >
//                     {dItem.commingsoon && (
//                       <span className="absolute top-0 left-4 text-xs text-orange-500 font-semibold">
//                         Coming Soon
//                       </span>
//                     )}
//                     <span className={dItem.commingsoon ? "pt-1 block" : ""}>
//                       {dItem.name}
//                     </span>
//                   </a>
//                 ))}
//               </div>
//             </div>
//           ))}
//         </nav>

//         {/* Right Side Icons */}
//         <div className="flex items-center space-x-4 ml-auto">
//           <button
//             className={`text-xl ${
//               canPostDeals
//                 ? "text-gray-600 hover:text-orange-500"
//                 : "text-gray-400 cursor-not-allowed"
//             }`}
//             onClick={handlePostDealClick}
//             disabled={!canPostDeals}
//             title={
//               canPostDeals
//                 ? "Post a New Deal"
//                 : `Deals post karne ke liye, KYC ${
//                     kycStatus === "not_submitted"
//                       ? "complete karein"
//                       : kycStatus === "pending"
//                       ? "approval pending hai"
//                       : "rejected hai"
//                   }`
//             }
//           >
//             <PlusCircleIcon className="h-6 w-6" />
//           </button>

//           <div className="relative cursor-pointer text-gray-600 hover:text-black">
//             <BellIcon className="h-6 w-6" />
//             <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 border border-white rounded-full" />
//           </div>

//           <div
//             className="relative cursor-pointer text-gray-600 hover:text-black flex items-center profile-dropdown-container"
//             onClick={() => {
//               setProfileDropdownOpen(!profileDropdownOpen);
//               setOpenDropdown(null);
//             }}
//           >
//             <UserCircleIcon className="h-7 w-7" />
//             <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />

//             <div
//               className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
//                 profileDropdownOpen ? "block" : "hidden"
//               }`}
//             >
//               <button
//                 onClick={() => {
//                   navigate("/MypersonalAccount");
//                   setProfileDropdownOpen(false);
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 My Profile
//               </button>
//               <button
//                 onClick={() => {
//                   handleLogout();
//                   setProfileDropdownOpen(false);
//                    localStorage.clear();
//                 }}
//                 className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
//               >
//                 Logout
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default VendorHeader;

// src/components/Dashboard/VendorHeader.jsx
import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  CalendarDaysIcon,
  ChartBarIcon,
  UserGroupIcon,
  BellIcon,
  PlusCircleIcon,
  UserCircleIcon,
  ChevronDownIcon,
} from "@heroicons/react/24/outline";
import { useAuth } from "../Authentication/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaMapMarkerAlt, FaTimes } from "react-icons/fa";

const Maps_API_KEY = "AIzaSyCRQXge0eI79YVPiihiUrqOKv4NapMnA9I";

const VendorHeader = () => {
  const { logout, canPostDeals, kycStatus } = useAuth();
  const navigate = useNavigate();

  const [openDropdown, setOpenDropdown] = useState(null);
  const [profileDropdownOpen, setProfileDropdownOpen] = useState(false);

  // State to manage modal visibility
  const [showLocationModal, setShowLocationModal] = useState(false);
  // State to store the user's selected/entered location
  const [currentLocation, setCurrentLocation] = useState({
    city: "Downtown",
    state: "San Francisco, California",
    latitude: null,
    longitude: null,
  });
  // State for the manual input field in the modal
  const [manualLocationInput, setManualLocationInput] = useState("");
  // State to track if Google Maps API is loaded
  const [isGoogleMapsLoaded, setIsGoogleMapsLoaded] = useState(false);
  // Ref for the manual location input field in the modal to attach autocomplete
  const locationInputModalRef = useRef(null);

  // Variable to hold the Google Places Autocomplete instance
  const autocompleteInstance = useRef(null);

  // Define the initMap callback function using useCallback
  // This is called when the Google Maps script finishes loading.
  const initMap = useCallback(() => {
    setIsGoogleMapsLoaded(true);
  }, []);

  // Load Google Maps API script dynamically and ensure it's loaded only once
  useEffect(() => {
    // Check if the script is already loaded
    if (window.google && window.google.maps && window.google.maps.places) {
      setIsGoogleMapsLoaded(true);
      return;
    }

    // Assign the initMap function to the global window object BEFORE appending the script
    // This is crucial for the Google Maps API's callback to work.
    window.initMap = initMap;

    // Check if a script with the Google Maps API source already exists
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );

    if (existingScript) {
      // If it exists, but isn't loaded, wait for it to load
      existingScript.onload = () => setIsGoogleMapsLoaded(true);
      existingScript.onerror = () =>
        toast.error("Failed to load Google Maps API.");
      return;
    }

    // If not, create and append the script
    const script = document.createElement("script");
    // We request 'places' and 'geocoding' libraries. 'places' is essential for Autocomplete.
    script.src = `https://maps.googleapis.com/maps/api/js?key=${Maps_API_KEY}&libraries=places&callback=initMap`;
    script.async = true;
    script.defer = true;
    script.id = "google-maps-script-header"; // Unique ID for this script

    script.onerror = () => {
      toast.error("Failed to load Google Maps API for location services.");
    };

    document.head.appendChild(script);

    return () => {
      // Clean up the global callback when the component unmounts
      if (window.initMap === initMap) {
        delete window.initMap;
      }
    };
  }, [initMap]); // Depend on initMap (which is stable due to useCallback)

  // Initialize Google Places Autocomplete when modal is open and API is loaded
  useEffect(() => {
    if (
      isGoogleMapsLoaded &&
      showLocationModal &&
      locationInputModalRef.current
    ) {
      // Ensure Autocomplete is only initialized once for this input
      if (!autocompleteInstance.current) {
        try {
          autocompleteInstance.current =
            new window.google.maps.places.Autocomplete(
              locationInputModalRef.current,
              {
                types: ["(cities)"], // Restrict results to cities (or 'geocode' for broader addresses)
                // Removed the country restriction to allow international locations
              }
            );

          autocompleteInstance.current.addListener("place_changed", () => {
            const place = autocompleteInstance.current.getPlace();

            if (place.geometry && place.formatted_address) {
              let city = "Unknown City";
              let state = ""; // Default to empty for state/country
              let latitude = place.geometry.location.lat();
              let longitude = place.geometry.location.lng();

              // Extract city and state/country from address_components
              const addressComponents = place.address_components;
              addressComponents.forEach((component) => {
                if (component.types.includes("locality")) {
                  city = component.long_name;
                } else if (
                  component.types.includes("administrative_area_level_1")
                ) {
                  state = component.long_name;
                } else if (component.types.includes("country")) {
                  // If state is not found, use country as fallback for 'state' field
                  if (!state) {
                    state = component.long_name;
                  }
                }
              });

              setCurrentLocation({
                city: city,
                state: state,
                latitude: latitude,
                longitude: longitude,
              });
              localStorage.setItem(
                "userLocation",
                JSON.stringify({
                  city: city,
                  state: state,
                  latitude: latitude,
                  longitude: longitude,
                })
              );
              setManualLocationInput(place.formatted_address); // Update input field with selected place's full address
              setShowLocationModal(false); // Close modal
              toast.success("Location updated!");
            } else {
              toast.warn("No details available for the selected location.");
              // If no geometry/formatted address, fall back to current input value
              handleManualLocationSubmit(true); // Treat as manual submission
            }
          });
        } catch (error) {
          console.error("Error initializing Google Autocomplete:", error);
          toast.error(
            "Failed to initialize location suggestions. Please try manual entry."
          );
        }
      }
    }

    // Cleanup: Remove listener and destroy autocomplete instance when modal closes or component unmounts
    return () => {
      if (autocompleteInstance.current) {
        if (window.google && window.google.maps && window.google.maps.event) {
          window.google.maps.event.clearInstanceListeners(
            autocompleteInstance.current
          );
        }
        autocompleteInstance.current = null;
      }
    };
  }, [isGoogleMapsLoaded, showLocationModal]); // Re-run when API loads or modal state changes

  // Effect to load location from local storage on component mount
  useEffect(() => {
    const storedLocation = localStorage.getItem("userLocation");
    if (storedLocation) {
      setCurrentLocation(JSON.parse(storedLocation));
    }
  }, []);

  // New useEffect to handle body overflow when modal is open/closed
  useEffect(() => {
    if (showLocationModal) {
      document.body.style.overflow = "hidden"; // Prevent scrolling
    } else {
      document.body.style.overflow = ""; // Allow scrolling
    }
    // Cleanup function to ensure overflow is reset if component unmounts while modal is open
    return () => {
      document.body.style.overflow = "";
    };
  }, [showLocationModal]); // Re-run effect whenever showLocationModal changes

  // Function to handle opening the location modal
  const handleLocationClick = () => {
    setShowLocationModal(true);
    setManualLocationInput(""); // Clear manual input when opening modal
  };

  // Function to handle closing the location modal
  const handleCloseModal = () => {
    setShowLocationModal(false);
  };

  // Function to get address details from coordinates using Google Geocoding API
  const getAddressFromCoordinates = async (latitude, longitude) => {
    if (!isGoogleMapsLoaded || !window.google || !window.google.maps) {
      toast.error("Google Maps API not fully loaded. Please try again.");
      return null;
    }

    const geocoder = new window.google.maps.Geocoder();
    const latlng = { lat: latitude, lng: longitude };

    try {
      const { results } = await geocoder.geocode({ location: latlng });

      if (results && results.length > 0) {
        let city = "Unknown City";
        let state = "Unknown Region";
        let country = "Unknown Country";

        const addressComponents = results[0].address_components;
        addressComponents.forEach((component) => {
          if (component.types.includes("locality")) {
            city = component.long_name;
          } else if (component.types.includes("administrative_area_level_1")) {
            state = component.long_name;
          } else if (component.types.includes("country")) {
            country = component.long_name;
          }
        });

        const displayState = state !== "Unknown Region" ? state : country;

        return {
          city: city,
          state: displayState,
          latitude,
          longitude,
        };
      } else {
        toast.warn("Could not find address details for your current location.");
        return {
          city: "Location Found",
          state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`, // Fallback to coords if address not found
          latitude,
          longitude,
        };
      }
    } catch (error) {
      console.error("Error reverse geocoding with Google Maps:", error);
      toast.error(
        "Failed to fetch address details. Check console for more info."
      );
      return null;
    }
  };

  // Function to get current geolocation and then reverse geocode it
  const handleUseCurrentLocation = async () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by your browser.");
      return;
    }
    if (!isGoogleMapsLoaded) {
      toast.info("Loading location services... please try again shortly.");
      return;
    }

    toast.info("Fetching your current location...");

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        const locationDetails = await getAddressFromCoordinates(
          latitude,
          longitude
        );

        if (locationDetails) {
          setCurrentLocation(locationDetails);
          localStorage.setItem("userLocation", JSON.stringify(locationDetails));
          toast.success("Location updated successfully!");
        } else {
          // Fallback if getAddressFromCoordinates returns null
          setCurrentLocation({
            city: "Unknown Address",
            state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(4)}`,
            latitude,
            longitude,
          });
          localStorage.setItem(
            "userLocation",
            JSON.stringify({
              city: "Unknown Address",
              state: `Lat: ${latitude.toFixed(4)}, Lon: ${longitude.toFixed(
                4
              )}`,
              latitude,
              longitude,
            })
          );
        }
        setShowLocationModal(false); // Close modal after fetching
      },
      (error) => {
        let errorMessage = "Unable to retrieve your location.";
        if (error.code === error.PERMISSION_DENIED) {
          errorMessage =
            "Location access denied. Please allow location services in your browser settings.";
        } else if (error.code === error.POSITION_UNAVAILABLE) {
          errorMessage = "Location information is unavailable.";
        } else if (error.code === error.TIMEOUT) {
          errorMessage = "The request to get location timed out.";
        }
        console.error("Geolocation error:", error);
        toast.error(errorMessage);
      }
    );
  };

  // Function to handle manual location submission
  // Added optional parameter to differentiate if called internally (e.g., from autocomplete fallback)
  const handleManualLocationSubmit = (fromAutocompleteFallback = false) => {
    if (manualLocationInput.trim() === "") {
      if (!fromAutocompleteFallback) {
        // Only warn if not a fallback from autocomplete
        toast.warn("Please enter a location.");
      }
      return;
    }

    const parts = manualLocationInput.split(",").map((p) => p.trim());
    const city = parts[0] || manualLocationInput.trim();
    const state = parts.length > 1 ? parts.slice(1).join(", ") : "";

    setCurrentLocation({
      city: city,
      state: state,
      latitude: null, // No lat/lng for simple manual entry without geocoding
      longitude: null, // No lat/lng for simple manual entry without geocoding
    });
    localStorage.setItem(
      "userLocation",
      JSON.stringify({
        city: city,
        state: state,
        latitude: null,
        longitude: null,
      })
    );
    setShowLocationModal(false); // Close modal after submission
    if (!fromAutocompleteFallback) {
      // Only show success toast if not a fallback
      toast.success("Manual location set successfully!");
    }
  };

  const navItems = [
    {
      name: "Deals",
      icon: CalendarDaysIcon,
      dropdownItems: [
        { name: "Browse Deal", path: "/PopularDeals" },
        { name: "Create Deal", path: "/vendor/deal/add" },
        { name: "My Created Deal", path: "/MyDeals" },
        { name: "Upcoming", path: "#", commingsoon: true },
        { name: "Past", path: "#", commingsoon: true },
      ],
    },
    {
      name: "Calendar",
      icon: ChartBarIcon,
      dropdownItems: [
        { name: "All Services", path: "#", commingsoon: true },
        { name: "Active Deals", path: "#", commingsoon: true },
      ],
    },
    {
      name: "Staff",
      icon: UserGroupIcon,
      dropdownItems: [
        { name: "Team", path: "#", commingsoon: true },
        { name: "Roles", path: "#", commingsoon: true },
      ],
    },
    {
      name: "Services",
      icon: UserGroupIcon,
      dropdownItems: [
        { name: "My Services", path: "/vendor/services" },
        { name: "Archived", path: "#", commingsoon: true },
      ],
    },
  ];

  const handlePostDealClick = () => {
    if (canPostDeals) {
      navigate("/Postdeal");
    } else if (kycStatus === "not_submitted") {
      alert("Deals post karne ke liye, kripya apni KYC complete karein.");
      navigate("/kyc-submission");
    } else if (kycStatus === "pending") {
      alert(
        "Aapki KYC approval pending hai. Approval ke baad deals post kar sakte hain."
      );
    } else if (kycStatus === "rejected") {
      alert("Aapki KYC reject ho gayi hai. Kripya dubara submit karein.");
      navigate("/kyc-submission");
    } else {
      alert("KYC status verify nahi hai. Kripya profile check karein.");
    }
  };

  const handleDropdownToggle = (index) => {
    setOpenDropdown(openDropdown === index ? null : index);
    setProfileDropdownOpen(false);
  };

  const handleDropdownItemClick = (item) => {
    if (item.path && !item.commingsoon) {
      navigate(item.path);
      setOpenDropdown(null);
    }
  };

  const handleLogout = () => {
    logout();
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest(".nav-dropdown-container")) {
        setOpenDropdown(null);
      }
      if (!e.target.closest(".profile-dropdown-container")) {
        setProfileDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className="bg-white shadow-sm py-4 px-6 border-b border-gray-200">
      <div className="container mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="flex-shrink-0 cursor-pointer">
          <img
            src="/upswap.png"
            alt="UpSwap"
            className="h-10"
            onClick={() => navigate("/")}
          />
        </div>

        {/* Location Display - Moved here */}
        <div
          className="flex items-center text-gray-700 hover:text-black text-sm font-medium cursor-pointer ml-4" // Added ml-4 and mr-8 for spacing
          onClick={handleLocationClick}
        >
          <FaMapMarkerAlt className="h-5 w-5 text-gray-500 mr-2" />
          <div className="flex flex-col">
            <div className="font-semibold leading-none">
              {currentLocation.city}
            </div>
            <div className="text-xs text-gray-500 leading-none">
              {currentLocation.state}
            </div>
          </div>
        </div>

        {/* Navigation */}
        <nav className="hidden lg:flex flex-grow justify-center space-x-8">
          {navItems.map((item, index) => (
            <div
              key={index}
              className="relative flex items-center text-gray-700 hover:text-black text-sm font-medium cursor-pointer nav-dropdown-container"
              onClick={() => handleDropdownToggle(index)}
            >
              {item.icon && <item.icon className="h-5 w-5 mr-1" />}
              {item.name}
              <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />

              <div
                className={`absolute top-full left-1/2 -translate-x-1/2 mt-2 w-44 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
                  openDropdown === index ? "flex flex-col gap-1" : "hidden"
                }`}
              >
                {item.dropdownItems.map((dItem, dIndex) => (
                  <a
                    key={dIndex}
                    href={dItem.commingsoon ? "#" : dItem.path}
                    className={`block px-4 py-2 text-sm relative  rounded-sm ${
                      dItem.commingsoon
                        ? "bg-gray-100 text-gray-400 cursor-not-allowed"
                        : "text-gray-700 hover:bg-gray-100"
                    }`}
                    onClick={(e) => {
                      e.stopPropagation();
                      if (!dItem.commingsoon) handleDropdownItemClick(dItem);
                    }}
                  >
                    {dItem.commingsoon && (
                      <span className="absolute top-0 left-4 text-xs text-orange-500 font-semibold">
                        Coming Soon
                      </span>
                    )}
                    <span className={dItem.commingsoon ? "pt-1 block" : ""}>
                      {dItem.name}
                    </span>
                  </a>
                ))}
              </div>
            </div>
          ))}
        </nav>

        {/* Right Side Icons */}
        <div className="flex items-center space-x-4 ml-auto">
          <button
            className={`text-xl ${
              canPostDeals
                ? "text-gray-600 hover:text-orange-500"
                : "text-gray-400 cursor-not-allowed"
            }`}
            onClick={handlePostDealClick}
            disabled={!canPostDeals}
            title={
              canPostDeals
                ? "Post a New Deal"
                : `Deals post karne ke liye, KYC ${
                    kycStatus === "not_submitted"
                      ? "complete karein"
                      : kycStatus === "pending"
                      ? "approval pending hai"
                      : "rejected hai"
                  }`
            }
          >
            <PlusCircleIcon className="h-6 w-6" />
          </button>

          <div className="relative cursor-pointer text-gray-600 hover:text-black">
            <BellIcon className="h-6 w-6" />
            <span className="absolute -top-1 -right-1 h-2 w-2 bg-red-500 border border-white rounded-full" />
          </div>

          <div
            className="relative cursor-pointer text-gray-600 hover:text-black flex items-center profile-dropdown-container"
            onClick={() => {
              setProfileDropdownOpen(!profileDropdownOpen);
              setOpenDropdown(null);
            }}
          >
            <UserCircleIcon className="h-7 w-7" />
            <ChevronDownIcon className="h-4 w-4 ml-1 text-gray-400" />

            <div
              className={`absolute top-full right-0 mt-2 w-48 bg-white border border-gray-200 rounded-md shadow-lg z-50 ${
                profileDropdownOpen ? "block" : "hidden"
              }`}
            >
              <button
                onClick={() => {
                  navigate("/MypersonalAccount");
                  setProfileDropdownOpen(false);
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                My Profile
              </button>
              <button
                onClick={() => {
                  handleLogout();
                  setProfileDropdownOpen(false);
                  localStorage.clear();
                }}
                className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
              >
                Logout
              </button>
            </div>
          </div>
        </div>

        {/* Location Modal (remains at the top level for overlay) */}
        {showLocationModal && (
          <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative bg-white p-6 rounded-lg shadow-xl w-full max-w-sm mx-4 md:max-w-md md:p-8">
              {/* Close Icon in top-right corner */}
              <button
                onClick={handleCloseModal}
                className="absolute top-3 right-3 p-2 rounded-full text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
                aria-label="Close location selection"
              >
                <FaTimes size={20} />
              </button>

              <h2 className="text-xl font-bold mb-4 text-gray-800">
                Select Your Location
              </h2>

              {/* Use Current Location Button */}
              <button
                onClick={handleUseCurrentLocation}
                disabled={!isGoogleMapsLoaded} // Disable if Google Maps API isn't loaded
                className={`w-full py-2 px-4 rounded-md transition mb-4 ${
                  !isGoogleMapsLoaded
                    ? "bg-blue-300 cursor-not-allowed"
                    : "bg-blue-500 text-white hover:bg-blue-600"
                }`}
              >
                <FaMapMarkerAlt className="inline-block mr-2" />
                {isGoogleMapsLoaded
                  ? "Use My Current Location"
                  : "Loading Location Services..."}
              </button>

              <div className="text-center text-gray-500 mb-4 font-semibold">
                - OR -
              </div>

              {/* Manual Location Input with Autocomplete */}
              <input
                type="text"
                ref={locationInputModalRef} // Assign ref to this input
                placeholder="Enter location manually (e.g., New York, USA)"
                className="w-full border border-gray-300 p-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 mb-4"
                value={manualLocationInput}
                onChange={(e) => setManualLocationInput(e.target.value)}
              />
              {/* The Set Location button is now primarily for when the user types and doesn't select a suggestion */}
              <button
                onClick={() => handleManualLocationSubmit()} // Call without fallback flag
                className="w-full bg-green-500 text-white py-2 px-4 rounded-md hover:bg-green-600 transition mb-4"
              >
                Set Location
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default VendorHeader;
